import React,{ useEffect, useState } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getOrderDetails, createRazorpayOrderAction, payOrder, orderDeliver } from '../../redux/actions/OrderActions';
import axios from 'axios';
import Loader from '../../components/Loader';
import Message from '../../components/Message';
import { ORDER_PAY_RESET, ORDER_DELIVER_RESET } from '../../redux/constants/OrderConstants';
import NavbarTwo from '../../components/navbar/NavbarTwo';
import { server_api } from '../../redux/actions/api'; 
import {
    Document,
    Page,
    Text,
    View,
    StyleSheet,
    Image,
    Font,
    PDFDownloadLink
} from "@react-pdf/renderer";
import LOGO from '../../assets/img/logo.png';
import SenRegular from '../../assets/font/Sen-Regular.ttf';
import SenBold from '../../assets/font/Sen-Bold.ttf';
import SenExtraBold from '../../assets/font/Sen-ExtraBold.ttf';




const OrderScreen = () => {

    const { orderId } = useParams()
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const [razorpayErr, setRazorpayErr] = useState('')

    const orderDetails = useSelector((state) => state.orderDetails)
    const {loading, order, error } = orderDetails;

    const razorpayOrder = useSelector((state) => state.razorpayOrder)
    const {razorpayResult, error:razorpayOrderErr } = razorpayOrder;

    const orderPay = useSelector((state) => state.orderPay)
    const {loading:loadingPay, success:successPay } = orderPay;

    const orderDelivered = useSelector((state) => state.orderDelivered)
    const {loading:loadingDeliver, success:successDeliver } = orderDelivered;

    const authLogin = useSelector((state) => state.authLogin)
    const { info } = authLogin;

    const auth = useSelector((state) => state.auth)
    const { authInfo } = auth;

    
    useEffect(() => {

        if (!info) {
            navigate('/login')
        }
        
        
        if (!order || successPay || successDeliver || order._id !== orderId) {
            dispatch({ type: ORDER_PAY_RESET })
            dispatch({ type: ORDER_DELIVER_RESET })
            dispatch(getOrderDetails(orderId))
        }

       
        
    }, [orderId, order, authLogin, dispatch, navigate, info, successPay, successDeliver])




    if (!loading) {
        const addDecimals = (num) => {
            return (Math.round(num * 100) / 100).toFixed(2)
        }
      
        order.itemsPrice = addDecimals(
            order.orderItems.reduce((acc, item) => acc + item.price * item.qty, 0)
        )
    }



    function successPaymentHandler(){
        const script = document.createElement('script');
        script.src = 'https://checkout.razorpay.com/v1/checkout.js';
        script.onerror = () => {
            setRazorpayErr('Razorpay SDK failed to load. Are you online?');
        };
        script.onload = async () => {
            try {

                dispatch(createRazorpayOrderAction({ amount: order.totalPrice }))
                
                const { data: { key: razorpayKey }, } = await axios.get(`${server_api}/get-razorpay-key`);
    
                const options = {
                    key: razorpayKey,
                    amount: razorpayResult.amount.toString(),
                    currency: razorpayResult.currency,
                    name: 'CRAFTIS',
                    description: 'Transaction',
                    order_id: razorpayResult.id,
                    handler: async function (response) {
                        const razorpay = {
                            razorpayPaymentId: response.razorpay_payment_id,
                            razorpayOrderId: response.razorpay_order_id,
                            razorpaySignature: response.razorpay_signature,
                        };
                        dispatch(payOrder(orderId, razorpay))
                    },
                    prefill: {
                        name: authInfo.name,
                        email: authInfo.email,
                        contact: authInfo.phone,
                    },
                    notes: {
                        address: order.shippingAddress.address,
                    },
                    theme: {
                        color: '#80c0f0',
                    },
                };
    
                const paymentObject = new window.Razorpay(options);
                paymentObject.open();
            } catch (err) {
                console.log(err);
            }
        };

        document.body.appendChild(script);
    }


    
    const successDeliverHandler = () => {
        dispatch(orderDeliver(orderId))
    }


    const invoiceNumber = Math.round(Math.random() * (100000 - 10000) + 10000)
    const now = new Date()
    const invoiceDate = now.getDate()
    const invoiceMonth = now.getMonth() + 1
    const invoiceYear = now.getFullYear()

    const InvoiceNow = invoiceDate + '/' + invoiceMonth + '/' + invoiceYear;


    return (
        <div className='bg-gray-50 min-h-screen'>
            <NavbarTwo />
            <div className='my-5'>
                <div className='container max-w-screen-xl mx-auto  px-4 md:px-2 '>
                {
                    info.role === 'admin' ? 
                    <Link to='/admin/orderList' className='px-5 py-3 bg-gray-200 hover:bg-gray-300 rounded text-md font-medium tracking-wider'> Home</Link> : 
                    <Link to='/' className='px-5 py-3 bg-gray-200 hover:bg-gray-300 rounded text-md font-medium tracking-wider'>Home</Link>
                }
                
                    { razorpayErr && <Message error msg={razorpayErr} /> }
                    { razorpayOrderErr && <Message error msg={razorpayOrderErr} /> }
                    {
                        loading ? <Loader /> : error ? <Message error msg={error} /> : (
                            <>
                                <h2 className='mb-16 mt-10 text-xl font-extrabold mont-font tracking-wider uppercase text-center'>order <span className='text-2xl font-extrabold'>{order && order._id}</span> </h2>
                                <div className='flex justify-between flex-col md:flex-row sen-font'>
                                    <div className='w-full md:mr-5'>
                                        <div className='mb-5 text-md'>
                                            <h2 className='mb-3 mont-font text-xl uppercase font-bold ]'>Person Details</h2>
                                            <p>
                                                <span className='font-semibold'>Name: </span>
                                                <span className='capitalize'>{ order.user ? order.user.name : '--'}</span>
                                            </p>
                                            <p className='my-1'>
                                                <span className='font-semibold'>Email: </span>
                                                <span className=''>{order.user ? order.user.email : '--'}</span>
                                            </p>
                                            <p>
                                                <span className='font-semibold'>Phone: </span>
                                                <span className='capitalize'>{order.user ? order.user.phone : '--'}</span>
                                            </p>
                                        </div>
                                        <hr className='my-5'/>
                                        <div className='mb-5 text-md'>
                                            <h2 className='mb-3 mont-font text-lg uppercase font-bold'>shipping address</h2>
                                            <p className='mb-1'>
                                                <span className='font-semibold'>Address: </span>
                                                <span className='capitalize'>{order && order.shippingAddress.address}</span>
                                            </p>
                                            <p className='mb-1'>
                                                <span className='font-semibold'>City: </span>
                                                <span className='capitalize'>{order && order.shippingAddress.city}</span>
                                            </p>
                                            <p className='mb-1'>
                                                <span className='font-semibold'>Landmark: </span>
                                                <span className='capitalize'>{order && order.shippingAddress.landmark}</span>
                                            </p>
                                            <p className='mb-1'>
                                                <span className='font-semibold'>Postal Code: </span>
                                                <span className='capitalize'>{order && order.shippingAddress.postalCode}</span>
                                            </p>
                                            <p className='mb-1'>
                                                <span className='font-semibold'>Country: </span>
                                                <span className='capitalize'>{order && order.shippingAddress.country}</span>
                                            </p>
                                        </div>
                                        {order && order.isDelivered ? (
                                            <Message success msg={`Delivered on ${order.deliveredAt}`} />
                                        ) : (
                                            <div className="p-3 my-4 text-md my-2 text-red-700 bg-red-100 rounded" role="alert">
                                                <span className="font-medium ">Not Delivered</span> 
                                            </div>
                                        )}
                                        <hr className='my-5'/>

                                        <div className='text-md'>
                                            <h2 className='mb-3 mont-font text-lg uppercase font-bold'>Payment Method</h2>
                                            <span className='font-semibold '>Method: </span>
                                            <span className='capitalize '>{order && order.paymentMethod}</span>
                                        </div>
                                        {order && order.isPaid ? (
                                            <Message success msg={`Paid on ${order.paidAt}`} />
                                        ) : (
                                            <div className="p-3 my-4 text-md my-2 text-red-700 bg-red-100 rounded" role="alert">
                                                <span className="font-medium ">Not Paid</span> 
                                            </div>
                                        )}
                                        <hr className='my-5' />
                                        <div>
                                            <h2 className='mb-3 mont-font text-xl uppercase font-bold'>Order Items</h2>
                                            {
                                            order && order.orderItems.map(item => (
                                                <div key={item.product} className='mb-4 shadow p-4 rounded bg-white'>
                                                    <div className='flex lg:flex-row flex-col lg:items-center'>
                                                        <div className='w-20'>
                                                            <img src={item.image} alt={item.name} className='w-20' />
                                                        </div>
                                                        <div  className='lg:w-96 lg:mx-5 lg:my-0 my-4 w-full'>
                                                            <Link to={`/product/${item.product}`} className='underline text-slate-500 mont-font'>{item.name}</Link>
                                                        </div>
                                                            
                                                        <div className='text-slate-500 sen-font'>{item.qty} x ₹{item.price} = <span className='text-black font-medium'>₹{item.qty * item.price}</span></div>
                                                    </div>
                                                </div>
                                            ))
                                        }
                                        </div>
                                    </div>
                                    <div className='w-full md:w-1/2 my-0 mx-auto md:ml-5'>
                                        <div className='border-2 text-md'>
                                            <h2 className='p-3 border-b-2 mont-font text-xl uppercase font-bold'>Order Summary</h2>
                                            <div className='flex p-3 justify-between items-center border-b-2' >
                                                <div className=''>Items</div>
                                                <div className='sen-font'>₹{order && order.itemsPrice}</div>
                                            </div>
                                            <div className='flex p-3 justify-between items-center border-b-2' >
                                                <div className=''>Shipping</div>
                                                <div className='sen-font'>₹{order && order.shippingPrice}</div>
                                            </div>
                                            <div className='flex p-3 justify-between items-center border-b-2' >
                                                <div className=''>Tax</div>
                                                <div className='sen-font'>₹{order && order.taxPrice}</div>
                                            </div>
                                            <div className='flex p-3 justify-between items-center border-b-2' >
                                                <div className=''>Total</div>
                                                <div className='sen-font'>₹{order && order.totalPrice}</div>
                                            </div>
                                            {
                                                order && !order.isPaid && (
                                                    <div className='p-3'>
                                                        {loadingPay && <Loader />}
                                                        <button 
                                                            className='uppercase text-sm tracking-wide bg-black sen-font w-full p-3 text-white disabled:hidden' 
                                                            onClick={successPaymentHandler}
                                                        >
                                                        Pay Order</button>
                                                    </div>
                                                )
                                            }
                                            {
                                                order && order.isPaid && (
                                                    <div className='p-3'>
                                                        {loadingPay && <Loader />}
                                                        {loading ? <Loader /> : error ? <Message error msg={error} /> : (
                                                            <PDFDownloadLink document={<MyDoc order={order} invoiceNumber={invoiceNumber} InvoiceNow={InvoiceNow} />} fileName="invoice.pdf">
                                                                {({ _blob, _url, loading, _error }) => (
                                                                    loading ? 'Loading document...' : 
                                                                        <button
                                                                            className='uppercase text-sm tracking-wide bg-black sen-font w-full p-3 text-white disabled:hidden'
                                                                        >
                                                                        Download Invoice</button>
                                                                    )
                                                                }
                                                            </PDFDownloadLink>
                                                        )}
                                                    </div>
                                                )
                                            }
                                            {loadingDeliver && <Loader />}
                                            { authInfo &&
                                                authInfo.role === 'admin' &&
                                                order.isPaid &&
                                                !order.isDelivered && (
                                                    <div className='p-3'>
                                                        <button 
                                                            className='uppercase text-sm tracking-wide bg-green-500  sen-font w-full p-3 text-white disabled:hidden' 
                                                            onClick={successDeliverHandler}
                                                        >
                                                        Mark as Delivered</button>
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>
                            
                            </>
                        )
                    }
                </div>
            </div>
        </div>
    )
}


export default OrderScreen;








// PDF DOCUMENT


Font.register({
    family: "Sen",
    fonts: [
        { src: SenRegular },
        { src: SenBold, fontStyle: 'normal', fontWeight: 400 },
        { src: SenExtraBold, fontStyle: 'normal', fontWeight: 700 },
    ]
})

// Font.register({
//     family: "Sen",
//     src: SenRegular,
// })


// Create styles
const styles = StyleSheet.create({
    page: {
        backgroundColor: "#ffffff",
        fontFamily: 'Sen'
    },
    logo: {
        width: 100,
        margin: 20

    },
    title: {
        fontSize: 20,
        letterSpacing: 2,
        fontWeight: 500,
        textAlign: 'center',
        marginTop: 20,
        marginBottom: 20,
        marginLeft: 20,
        marginRight: 20,
    },
    viewer: {
        width: window.innerWidth,
        height: window.innerHeight,
    },
    person: {
        display: "flex",
        justifyContent: 'space-between',
        flexDirection: 'row',
        margin: 20
    },

    person_title: {
        fontSize: 13,
        marginBottom: 10,
        textTransform: 'uppercase',
        color: "#DC143C",
        fontWeight: 500
    },

    table: {
        display: "table",
        width: "auto",
        borderStyle: "solid",
        borderWidth: 1,
        // borderRightWidth: 0,
        // borderBottomWidth: 0,
        marginTop: 20,
        marginLeft: 20,
        marginRight: 20,
        marginBottom: 10,
        fontSize: 12
    },
    tableRow: {
        margin: "auto",
        flexDirection: "row",
        marginTop: 7,
        marginBottom: 7
    },
    tableHeader: {
        margin: "auto",
        flexDirection: "row",
        backgroundColor: '#003049',
        color: '#ffffff',
        padding: 10
    },
    tableHeaderCol: {
        width: "20%",
    },
    tableCol: {
        width: "20%",
    },
    tableCell: {
        margin: "auto",
        marginTop: 5,
        fontSize: 10
    },

    orderSummary: {
        display: "flex",
        justifyContent: 'space-between',
        flexDirection: 'row',
        marginRight: 20,
        marginLeft: 20,
        marginBottom: 20,
    },

});



const MyDoc = ({ order, invoiceNumber, InvoiceNow }) => (
    <Document>
        <Page size="A4" style={styles.page}>
            <View>
                <Image src={LOGO} style={styles.logo} />
            </View>
            <View style={styles.title}>
                <Text>INVOICE</Text>
            </View>

            <View style={styles.person}>
                <View>
                    <Text style={{ fontSize: 12, marginBottom: 5 }}><Text style={{ color: '#457b9d', }}>Invoice Number: </Text>#{invoiceNumber}</Text>
                </View>
                <View>
                    <Text style={{ fontSize: 12 }}><Text style={{ color: '#457b9d', }}>Invoice Date: </Text>{InvoiceNow}</Text>
                </View>
            </View>

            <View style={styles.person}>
                <View style={{ display: "flex", flexDirection: "column" }}>
                    <Text style={styles.person_title}>Person Details</Text>
                    <Text style={{ fontSize: 12, marginBottom: 5 }}><Text style={{ color: '#457b9d', }}>Name: </Text>{order.user ? order.user.name : '--'}</Text>
                    <Text style={{ fontSize: 12, marginBottom: 5 }}><Text style={{ color: '#457b9d', }}>Email: </Text>{order.user ? order.user.email : '--'}</Text>
                    <Text style={{ fontSize: 12 }}><Text style={{ color: '#457b9d', }}>Phone: </Text>{order.user ? order.user.phone : '--'}</Text>
                </View>
                <View style={{ display: "flex", flexDirection: "column" }}>
                    <Text style={{ fontSize: 12, marginBottom: 5 }}><Text style={{ color: '#457b9d' }}>Order ID: </Text>{order ? order._id : '--'}</Text>
                    <Text style={{ fontSize: 12 }}><Text style={{ color: '#457b9d' }}>Date: </Text>{order ? order.createdAt.substring(0, 10) : '--'}</Text>
                </View>
            </View>

            <View style={styles.person}>
                <View style={{ display: "flex", flexDirection: "column" }}>
                    <Text style={styles.person_title}>SHIPPING ADDRESS</Text>
                    <Text style={{ fontSize: 12, marginBottom: 5 }}><Text style={{ color: '#457b9d', }}>Address: </Text>{order && order.shippingAddress.address}</Text>
                    <Text style={{ fontSize: 12, marginBottom: 5 }}><Text style={{ color: '#457b9d', }}>City: </Text>{order && order.shippingAddress.city}</Text>
                    <Text style={{ fontSize: 12, marginBottom: 5 }}><Text style={{ color: '#457b9d', }}>Landmark: </Text>{order && order.shippingAddress.landmark}</Text>
                    <Text style={{ fontSize: 12, marginBottom: 5 }}><Text style={{ color: '#457b9d', }}>Postal Code: </Text>{order && order.shippingAddress.postalCode}</Text>
                    <Text style={{ fontSize: 12 }}><Text style={{ color: '#457b9d', }}>Country: </Text>{order && order.shippingAddress.country}</Text>
                </View>
                <View style={{ display: "flex", flexDirection: "column", }}>
                    <Text style={styles.person_title}>PAYMENT METHOD</Text>
                    <Text style={{ fontSize: 12, marginBottom: 5 }}><Text style={{ color: '#457b9d', }}>Payment ID: </Text>{order && order.razorpay.paymentId}</Text>
                    <Text style={{ fontSize: 12, marginBottom: 5 }}><Text style={{ color: '#457b9d', }}>Method: </Text>Razorpay</Text>
                    <Text style={{ fontSize: 12, }}><Text style={{ color: '#457b9d', }}>Paid At: </Text>{order ? order.paidAt.substring(0, 10) : '--'}</Text>
                </View>
            </View>

            <View style={{ textTransform: 'uppercase', marginTop: 20, marginLeft: 20, marginRight: 20, fontSize: 13, color: '#DC143C', fontWeight: 500 }}>
                <Text>Products</Text>
            </View>

            <View style={styles.table}>
                <View style={styles.tableHeader}>
                    <View style={styles.tableHeaderCol}>
                        <Text style={styles.tableCell}>#</Text>
                    </View>
                    <View style={styles.tableHeaderCol}>
                        <Text style={styles.tableCell}>Product</Text>
                    </View>
                    <View style={styles.tableHeaderCol}>
                        <Text style={styles.tableCell}>Price (Rs)</Text>
                    </View>
                    <View style={styles.tableHeaderCol}>
                        <Text style={styles.tableCell}>Qty</Text>
                    </View>
                    <View style={styles.tableHeaderCol}>
                        <Text style={styles.tableCell}>Total (Rs)</Text>
                    </View>
                </View>
                {
                    order && order.orderItems.map(item => (
                        <View style={styles.tableRow}>
                            <View style={styles.tableCol}>
                                <Text style={styles.tableCell}>1</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={styles.tableCell}>{item.name}</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={styles.tableCell}>{item.price}</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={styles.tableCell}>{item.qty}</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={styles.tableCell}>{item.price}</Text>
                            </View>
                        </View>
                    ))
                }

            </View>


            <View style={styles.orderSummary}>
                <View></View>
                <View style={{ display: "flex", flexDirection: "column", marginRight: 35 }}>
                    <Text style={{ fontSize: 12, marginBottom: 7 }}><Text style={{ color: '#457b9d', }}>Items (Rs): &nbsp;  &nbsp;  &nbsp; </Text> {order && order.itemsPrice}</Text>
                    <Text style={{ fontSize: 12, marginBottom: 7 }}><Text style={{ color: '#457b9d', }}>Shipping (Rs):  &nbsp;  &nbsp;  &nbsp;  &nbsp;  &nbsp; </Text>{order && order.shippingPrice}</Text>
                    <Text style={{ fontSize: 12, marginBottom: 10 }}><Text style={{ color: '#457b9d', }}>Tax (Rs):  &nbsp;  &nbsp;  &nbsp;  &nbsp; &nbsp; &nbsp;</Text>{order && order.taxPrice}</Text>
                    <Text style={{ border: 1 }}></Text>
                    <Text style={{ fontSize: 15, marginTop: 10, fontWeight: 500 }}><Text style={{ color: '#DC143C', }}>Total (Rs): &nbsp; &nbsp;</Text>{order && order.totalPrice}</Text>
                </View>
            </View>
        </Page>
    </Document>
)